import React from 'react'
import { withIcon } from '../../withIcon'

function ShareIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M13.4897 4.74384C13.1749 5.06896 13.1749 5.59609 13.4897 5.92121L15.3377 7.83009H10.6343C8.07483 7.83009 6 9.97331 6 12.6171V18.6675C6 19.1273 6.36084 19.5 6.80596 19.5C7.25108 19.5 7.61192 19.1273 7.61192 18.6675V12.6171C7.61192 10.8929 8.96507 9.49514 10.6343 9.49514H15.1589L13.4897 11.2194C13.1749 11.5445 13.1749 12.0716 13.4897 12.3967C13.8044 12.7219 14.3147 12.7219 14.6295 12.3967L17.7639 9.15898C18.0787 8.83386 18.0787 8.30673 17.7639 7.98161L14.6295 4.74384C14.3147 4.41872 13.8044 4.41872 13.4897 4.74384Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ShareIcon)
